import Button from "@/components/Button";
import Input from "@/components/Input";
import Dropdown from "@/components/Dropdown";
import InputCurrency from "@/components/InputCurrency";
import TextArea from "@/components/TextArea";
import NO_IMAGE_SQUARE from "@/assets/icons/no-image-square.svg";
import UploadedImageItem from "./components/UploadedImageItem";
import SelectImage from "@/components/SelectImage";
import UploadingItem from "./components/UploadingItem";
import { ChangeEvent, useEffect, useState } from "react";
import "./style.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { validateImageResolution } from "@/utils/image";
import uploadFileInteractor from "@/@core/interactor/media/upload-file";
import createProductInteractor from "@/@core/interactor/product/create-product";
import { BASE_URL, DROPDOWN_CATEGORY_PRODUCT_OPTIONS } from "@/utils/constant";
import getProductDetailInteractor from "@/@core/interactor/product/get-product-id";
import updateProductInteractor from "@/@core/interactor/product/update-product";
import toast, { Toaster } from "react-hot-toast";
import deletetMediaInteractor from "@/@core/interactor/media/delete-media";

const ProductForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { pathname } = useLocation();
  const splitPath = pathname.split("/");

  const [productPictures, setProductPictures] = useState<any>([]);
  const [mediaId, setMediaId] = useState<string[]>([]);
  const [getMediaId, setGetMediaId] = useState<string[]>([])
  const [formInput, setFormInput] = useState({
    name: "",
    category: DROPDOWN_CATEGORY_PRODUCT_OPTIONS[0],
    master_sku: "",
    season: "",
    size: "",
    colour: "",
    price: "",
    description: "",
  });

  const disabledCreate =
    !formInput.name ||
    !formInput.master_sku ||
    !formInput.season ||
    !formInput.price ||
    mediaId.length === 0;

  const getProductDetail = async () => {
    try {
      const res = await getProductDetailInteractor({ id });
      const {
        data: {
          data: {
            name,
            category,
            season,
            size,
            master_sku,
            colour,
            price,
            description,
            images,
          },
        },
      } = res;

      const newCategory = DROPDOWN_CATEGORY_PRODUCT_OPTIONS.find(
        (item) => item.value === category
      );
      const newImagesUrl = images.map(
        (item: any) => BASE_URL + "/file" + item.path
      );
      const newMediaId = images.map((item: any) => item.id);

      setFormInput({
        name,
        season,
        size,
        colour,
        master_sku,
        price: String(price),
        description,
        category: newCategory || DROPDOWN_CATEGORY_PRODUCT_OPTIONS[0],
      });
      setProductPictures(newImagesUrl);
      setMediaId(newMediaId);
      setGetMediaId(newMediaId)
    } catch (err) {}
  };

  const createProduct = async () => {
    try {
      const body = {
        ...formInput,
        price: parseFloat(formInput.price.replace(/\./g, "")),
        category: formInput?.category?.value,
        media_ids: mediaId,
        status: 1,
      };
      await createProductInteractor(body);

      toast.success(`${formInput.name} has been create`);
    } catch (err) {
      console.error(err);
    }
  };

  const updateProduct = async () => {
    try {
      const body = {
        ...formInput,
        price: parseFloat(formInput.price.replace(/\./g, "")),
        category: formInput?.category?.value,
        media_ids: mediaId,
        status: 1,
      };

      const deleteIdMedia = getMediaId.filter((item) => !mediaId.includes(item))
      
      deleteIdMedia.forEach(async (id) => await deletetMediaInteractor(id)) 
      await updateProductInteractor(body, String(id));
      toast.success(`${formInput.name} has been updated`);
    } catch (err) {
      console.error(err);
    }
  };

  const onChangeInput = (e: any) => {
    const {
      target: { value, id },
    } = e;

    setFormInput({ ...formInput, [id]: value });
  };

  const handleChangeInputCurrency = (val: string) => {
    setFormInput({ ...formInput, price: val });
  };

  const handleChangeCategory = (e: any) => {
    setFormInput({ ...formInput, category: e });
  };

  const onSelectProductPicture = async (e: ChangeEvent<HTMLInputElement>) => {
    const files: any = e.target.files;

    try {
      if (!files[0].type.startsWith("image/")) {
        alert("The uploaded file must be an image");
        return;
      }

      const isResolutionValid = await validateImageResolution(
        files[0],
        2048,
        2048
      );

      if (isResolutionValid) {
        if (files && files.length) {
          const responseUploadFile = await uploadFileInteractor(files[0]);

          setMediaId([...mediaId, responseUploadFile?.data?.data?.id]);

          const temp = JSON.parse(JSON.stringify(productPictures));

          for (let i = 0; i < files.length; i += 1) {
            const objectUrl = URL.createObjectURL(files[i]);
            temp.push(objectUrl);
          }

          setProductPictures(temp);
        }
      } else {
        alert(
          "Image resolution is too high. Maximum resolution allowed is 2048x2048"
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onSave = async () => {
    try {
      if (id) {
        await updateProduct();
      } else {
        await createProduct();
      }
      navigate("/products");
    } catch (err) {
      console.error(err);
    }
  };

  const onSaveAdd = async () => {
    try {
      await createProduct();

      setFormInput({
        name: "",
        category: DROPDOWN_CATEGORY_PRODUCT_OPTIONS[0],
        master_sku: "",
        season: "",
        size: "",
        colour: "",
        price: "",
        description: "",
      });
      setProductPictures([]);
      setMediaId([]);
    } catch (err) {
      console.error(err);
    }
  };

  const onRemoveProductPicture = (index: number) => {
    const temp = JSON.parse(JSON.stringify(productPictures));
    const tempMedia = [...mediaId]
    tempMedia.splice(index, 1)
    temp.splice(index, 1);
    setProductPictures(temp);
    setMediaId(tempMedia);
  };

  useEffect(() => {
    if (id) getProductDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      <div className="product-form-page-wrapper">
        {splitPath[2] !== "product-detail" && (
          <div className="page-header-section">
            <h1>Add Products</h1>
            <div className="btn-wrapper">
              <Button
                onClick={() => navigate(-1)}
                label="Cancel"
                type="secondary"
                size="md"
              />
              {!id && (
                <Button
                  onClick={onSaveAdd}
                  label="Save & Add New"
                  type="light"
                  size="md"
                  disabled={disabledCreate}
                />
              )}
              <Button
                disabled={disabledCreate}
                onClick={onSave}
                label="Save"
                size="md"
                startIcon="save"
              />
            </div>
          </div>
        )}
        <div className="page-content">
          <div className="field-wrapper">
            <div className="left-section">
              <label>Name</label>
            </div>
            <div className="right-section">
              <Input
                style={{ width: "512px" }}
                id="name"
                value={formInput.name}
                onChange={onChangeInput}
                placeholder="Product name"
                disabled={splitPath[2] === "product-detail"}
              />
            </div>
          </div>

          <div className="field-wrapper">
            <div className="left-section">
              <label>Category</label>
            </div>
            <div className="right-section">
              <Dropdown
                placeHolder="Select category"
                value={formInput.category}
                options={DROPDOWN_CATEGORY_PRODUCT_OPTIONS}
                onChange={handleChangeCategory}
                disabled={splitPath[2] === "product-detail"}
                optionType="text-option"
                width="512px"
              />
            </div>
          </div>

          <div className="field-wrapper">
            <div className="left-section">
              <label>Detail Information</label>
            </div>
            <div
              className="right-section"
              style={{ display: "flex", gap: "24px" }}
            >
              <div className="block-wrapper">
                <div className="sub-item" style={{ marginBottom: "32px" }}>
                  <label>Master SKU</label>
                  <Input
                    style={{ width: "244px" }}
                    id="master_sku"
                    value={formInput.master_sku}
                    onChange={onChangeInput}
                    disabled={splitPath[2] === "product-detail"}
                  />
                </div>

                <div className="sub-item">
                  <label>Size</label>
                  <Input
                    style={{ width: "244px" }}
                    id="size"
                    value={formInput.size}
                    onChange={onChangeInput}
                    disabled={splitPath[2] === "product-detail"}
                  />
                </div>
              </div>

              <div className="block-wrapper">
                <div className="sub-item" style={{ marginBottom: "32px" }}>
                  <label>Season</label>
                  <Input
                    style={{ width: "244px" }}
                    id="season"
                    value={formInput.season}
                    onChange={onChangeInput}
                    disabled={splitPath[2] === "product-detail"}
                  />
                </div>

                <div className="sub-item">
                  <label>Colour</label>
                  <Input
                    style={{ width: "244px" }}
                    id="colour"
                    value={formInput.colour}
                    onChange={onChangeInput}
                    disabled={splitPath[2] === "product-detail"}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="field-wrapper">
            <div className="left-section">
              <label>Price</label>
            </div>
            <div className="right-section">
              <InputCurrency
                value={formInput.price}
                onChange={handleChangeInputCurrency}
                width="482px"
                disabled={splitPath[2] === "product-detail"}
              />
            </div>
          </div>

          <div className="field-wrapper">
            <div className="left-section">
              <label>Description</label>
              <span className="desc">Write a short introduction.</span>
            </div>
            <div className="right-section">
              <TextArea
                maxLength={2000}
                id="description"
                value={formInput.description}
                onChange={onChangeInput}
                placeholder="Product description"
                disabled={splitPath[2] === "product-detail"}
              />
            </div>
          </div>

          <div className="field-wrapper">
            <div className="left-section">
              <label>Photo</label>
            </div>
            <div className="right-section">
              <div className="uploded-image-section">
                {productPictures.map((img: any, index: number) => (
                  <UploadedImageItem
                    key={index}
                    imageSrc={img}
                    onRemove={
                      splitPath[2] !== "product-detail"
                        ? () => onRemoveProductPicture(index)
                        : undefined
                    }
                  />
                ))}

                {splitPath[2] !== "product-detail" &&
                  productPictures.length < 10 && (
                    <UploadedImageItem imageSrc={NO_IMAGE_SQUARE} />
                  )}
              </div>

              {splitPath[2] !== "product-detail" && (
                <>
                  <div style={{ marginTop: "20px" }}>
                    <SelectImage
                      width="calc(100% - 20px)"
                      onChange={onSelectProductPicture}
                      disabled={productPictures.length === 10}
                      displayIcon
                      desc="SVG, PNG, JPG or GIF (max. 1200x1200px)"
                      multiple
                    />
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    <UploadingItem
                      fileType="JPG"
                      fileName="DRX_Dewa_United_Away_2022_2023_Away_1.jpg"
                      fileSize="3.74 MB"
                      percentage={70}
                      isFail
                    />
                  </div>

                  <div style={{ marginTop: "20px" }}>
                    <UploadingItem
                      fileType="PNG"
                      fileName="DRX_Dewa_United_Away_2022_2023_Away_1.jpg"
                      fileSize="3.74 MB"
                      percentage={70}
                      isFail={false}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default ProductForm;
